exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".privacy-green{color:green}.privacy-red{color:red}.privacy-yellow{color:#ff0}.privacy-dropdown-toggle{border-radius:0;background-color:#000}.privacy-dropdown-toggle:focus{background-color:#000}.privacy-dropdown-menu.show{border-radius:0;background-color:#000;padding:0}.btn-secondary{color:#4e555b;background-color:#000;border-color:#4e555b}.btn-secondary:hover{color:#ffc000;background-color:#000;border-color:#ffc000}.dropdown-item{color:#999}.dropdown-item:hover{color:#ffc000;text-decoration:none;background-color:#111}.btn-secondary:not(:disabled):not(.disabled).active,.btn-secondary:not(:disabled):not(.disabled):active,.show>.btn-secondary.dropdown-toggle{background-color:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/forms/PrivacyDropdown/styles.scss
// module id = 604
// module chunks = 0